import * as React from "react";
import { useHistory } from "react-router-dom";

import { parseQueryParams } from "../../../libs/Util";
import {
  Context,
  login,
  authenticationPath,
  clearOTT,
} from "../../../teacherStore";
import LoginForm from "../../../templates/teacher/LoginForm";

export default () => {
  const { dispatch, state } = React.useContext(Context);
  const history = useHistory();
  const loginFunc = React.useCallback(
    (email: string, password: string, remember: boolean) => {
      dispatch(login(email, password, remember));
    },
    [dispatch],
  );
  const [error, setError] = React.useState(parseQueryParams()["message"]);
  React.useEffect(() => {
    if (state.error) {
      setError(state.error);
    }
  }, [state.error]);

  React.useEffect(() => {
    if (state.ott) {
      history.push(`${authenticationPath}/${state.ott}`);
      dispatch(clearOTT());
    }
  }, [dispatch, history, state.ott]);

  return <LoginForm login={loginFunc} error={error} />;
};
